import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { ExcelExportComponent, WorkbookOptions } from '@progress/kendo-angular-excel-export';


@Component({
  selector: 'expenses-report',
  template: `
    <kendo-excelexport [filterable]="true">
      <kendo-excelexport-column field="x" title="#" width="50"></kendo-excelexport-column>      
      <kendo-excelexport-column field="date" title="Fecha" width="180"></kendo-excelexport-column>      
      <kendo-excelexport-column field="supplier" title="Proveedor" width="200"></kendo-excelexport-column>
      <kendo-excelexport-column field="expense_type_name" title="Tipo de gasto" width="200"></kendo-excelexport-column>
      <kendo-excelexport-column field="description" title="Descripción" width="200"></kendo-excelexport-column>
      <kendo-excelexport-column field="cost" title="Costo" width="120" [cellOptions]="{ format: '$#,##0.00' }">
        <ng-template kendoExcelExportFooterTemplate>
          
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="payment_type_name" title="Tipo de pago" width="200"></kendo-excelexport-column>
      <kendo-excelexport-column field="person_authorize_name" title="Autoriza" width="300"></kendo-excelexport-column>
      <kendo-excelexport-column field="observations" title="Observaciones" width="250"></kendo-excelexport-column>
    </kendo-excelexport>`,
  styles: [``],
})
export class ExpensesReportComponent implements OnInit {

  //ExcelExport
  @ViewChild(ExcelExportComponent, {static: false}) report !: ExcelExportComponent;

  public name: string = 'report';

  protected table: string = 'expenses_inventories';  

  constructor(protected service : DatasourceService) { 

  }

  public downloadByStatus(id_crane_status: number = 0) {

    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [{field: 'date', dir: 'desc'}], 
      filter: {
        logic: "and",
        filters: []
      }, 
      group: []
    }

    // if(id_crane_status != 0){
    //   // state.filter.filters.push({
    //   //     field: 'id_crane_status',
    //   //     operator: 'eq',
    //   //     value: id_crane_status
    //   // })
    // }

    this.readData(state);

  }

  public downloadByRange(range: any) {

    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [{field: 'date', dir: 'desc'}], 
      filter: {
        logic: "or",
        filters: [
          {
            field: 'date',
            operator: 'inrange',
            value: `${range.start} 00:00:00,${range.end} 23:59:59`
          }
        ]
      }, 
      group: []
    }

    this.readData(state);

  }

  protected readData(state: State) {    

    this.service.get(this.table, state)
      .subscribe(
        (res) => {
          console.log("RESPONSE: ", res);
          this.report.fileName = `${this.name}.xlsx`;
          this.report.data = res.data; 
          let options: WorkbookOptions = this.applyFormat(this.report);
          this.report.save(options);

        },
        (fail) => {        
          console.log("Error", fail);
        }
      ); 

  }

  protected applyFormat(report: ExcelExportComponent): WorkbookOptions {

    const options = report.workbookOptions();
    const rows = options.sheets[0].rows;
    const columns = rows[0].cells;
    // console.log(rows, columns);
    
    let index: number = 0;
    let total: number = 0;
    rows.forEach((row) => {
      if (row.type === "data") {
        index++;        
        row.cells.forEach((cell, i) => {
          if(typeof columns[i].value != 'undefined'){
            switch(columns[i].value){ 
              case '#': {
                cell.value = index;
              }; break;             
              // case 'Estatus': {
              //   cell.background = '#' + report.data[index-1].service_status_color;
              //   cell.color = '#ffffff';
              // }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
                total= total + ((cell.value != null) ? parseFloat(<any>cell.value): 0);  
              }; break; 
            }
          }
        });
      } 
      else if (row.type === "footer") {
        row.cells.forEach((cell, i) => {
          if(typeof columns[i].value != 'undefined'){
            switch(columns[i].value){ 
              case 'Costo': {
                cell.value = total;
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

    return options;

  }

  ngOnInit() {

  }

}
